import { Component, OnInit, ViewChild, ViewEncapsulation, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatStepper } from '@angular/material/stepper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { AuthService } from './core/authentication/auth.service';
import { ClickToCallComponent } from './modules/click-to-call/click-to-call.component';
import { HomeserveService } from './shared/services/homeserve.service';
import { LocaleService } from './shared/services/locale.service';
import { MasterDataService } from './shared/services/master-data.service';
import { DataLayerService } from './core/services/dataLayer.service';
import { StorageService } from './shared/services/storage.service';
import { UrlParamsService } from './core/services/url-params.service';
import packageInfo from '../../../../package.json';
import { Language } from './shared/models/language';
import { MedalliaService } from './core/services/medallia.service';
declare global {
  interface Window { dataLayer: any[]; }
}
@Component({
	selector: 'homeserve-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [DataLayerService]
})
export class AppComponent implements OnInit {
	title = 'apertura-digital';
	private modalOpen = false;
	private readonly defaultLangi18n = 'es';
	showC2CButton: boolean = true;
	showStepper: boolean = true;
	oldUrl = window.URL;
	public readonly defaultLanguage: Language = this.masterDataService.getLanguages()[0];
	get language() {
		return this.homeserveService.getSelectedLanguage().i18nKey;
	}

	@ViewChild('stepper') stepper!: MatStepper;

	constructor(
		private translate: TranslateService,
		private localeService: LocaleService,
		private modalService: NgbModal,
		private authService: AuthService,
		private homeserveService: HomeserveService,
		private masterdataService: MasterDataService,
		private dataLayerService: DataLayerService,
    private storageService: StorageService,
    private urlParamsService: UrlParamsService,
	private masterDataService: MasterDataService,
	private medalliaService: MedalliaService,
	@Inject(DOCUMENT) private document: Document
	) {
		
	}

	ngOnInit() {
		
		console.log('Apertura digital: environment ' + environment.name);
		if(packageInfo && packageInfo.version) {
			console.log("APP version = " + packageInfo.version);
		}
		
		this.dataLayerService.getCookies();
		this.translate.setDefaultLang(this.defaultLangi18n);
		this.translate.use(this.defaultLangi18n);
		const language =
			this.masterdataService.getLanguages().find((lang) => lang.i18nKey === this.defaultLangi18n) ??
			this.homeserveService.defaultLanguage;
		this.homeserveService.setSelectedLanguage(language);



		
		this.document.documentElement.lang = this.language;
		const urlParamsString = JSON.stringify(this.storageService.get('urlParams'));
		if(urlParamsString){
			const urlParams = JSON.parse(urlParamsString);
			if(urlParams && urlParams.lang && urlParams.lang.i18nKey){
				this.document.documentElement.lang = urlParams.lang.i18nKey;
				const language =
					this.masterdataService.getLanguages().find((lang) => lang.i18nKey === urlParams.lang.i18nKey) ??
					this.homeserveService.defaultLanguage;
		this.homeserveService.setSelectedLanguage(language);
			} 
		}

		this.translate.onLangChange.subscribe((langEvent: LangChangeEvent) => {
	
			var lang: Language = this.masterDataService.getLanguages().find((lang) => lang.i18nKey === langEvent.lang) ?? this.defaultLanguage;
			document.cookie = "language="+ lang.i18nKey + "; SameSite=Lax; Secure";
			this.medalliaService.setValue('language', lang.i18nKey);
			
		});


		setTimeout(() => {
			const urlParamsString = JSON.stringify(this.storageService.get('urlParams'));
			if(urlParamsString){
				const urlParams = JSON.parse(urlParamsString);
				if (!urlParams.data){
					window.location.href = environment.adeslas;
				} 
			} else {
				window.location.href = environment.adeslas;
			}
		}, 1000);
	}

	useLanguage(language: string): void {
		this.translate.use(language);
		this.localeService.registerCulture(language);
	}

	onNextStep() {
		this.stepper.next();
	}

	onShowC2CButton(event: any) {
		this.showC2CButton = event;
	}

	onShowStepper(event: any) {
		this.showStepper = event;
	}

	showClickToCall() {
		const modalRef = this.modalService.open(ClickToCallComponent, {
			centered: true,
			windowClass: 'modal-call',
			backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.motiveC2C = '10008_Peticion_C2C_Cliente';
		modalRef.componentInstance.submotiveC2C = 'C2C llamado desde botón flotante';
	}

	get isValidToken() {
		return this.authService.isValidToken();
	}
}